import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-eglurhad',
    templateUrl: './eglurhad.component.html',
    styleUrls: ['./eglurhad.component.scss'],
    imports: [FaIconComponent, TranslatePipe]
})
export class EglurhadComponent extends FieldArrayType {

  constructor() {
    super();
  }
}
